module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ui-toolbar', {
    attrs: {
      "type": "colored",
      "text-color": "white",
      "loading": _vm.loading,
      "preloader-top": _vm.preloaderTop,
      "remove-nav-icon": _vm.hideNavIcon,
      "flat": true,
      "show-brand": _vm.showBrand
    },
    on: {
      "nav-icon-click": _vm.navIconClick
    }
  }, [_c('div', {
    slot: "brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.home'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    slot: "actions"
  }, [_c('div', {
    staticClass: "toolbar-menu"
  }, [_c('ui-button', {
    attrs: {
      "type": "clear"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.messages.dashboard'
        })
      }
    }
  }, [_vm._v("Wiadomości")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "clear"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.dashboard'
        })
      }
    }
  }, [_vm._v("Subskrybenci")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-full grid-pad"
  }, [(_vm.menuLeft) ? _c('div', {
    staticClass: "col-2-12"
  }, [_c('left-menu', {
    attrs: {
      "items": _vm.leftMenuItems
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: [
      _vm.menuLeft ? 'col-10-12' : 'col-1-1'
    ]
  }, [_c('div', {
    staticClass: "admin-content"
  }, [_c('router-view'), _vm._v(" "), _c('ui-confirm', {
    ref: "confirm1",
    attrs: {
      "type": "primary",
      "confirm-button-text": _vm.confirm.confirmButton,
      "deny-button-text": _vm.confirm.denyButton,
      "autofocus": "confirm-button",
      "close-on-confirm": true,
      "backdrop-dismissible": true,
      "title": _vm.confirm.confirm
    },
    on: {
      "confirm": _vm.confirmed,
      "deny": _vm.denied
    }
  }, [_vm._v("\n          " + _vm._s(_vm.confirm.message) + "\n        ")])], 1)])]), _vm._v(" "), _c('ui-snackbar-container', {
    ref: "snackbarContainer",
    attrs: {
      "position": _vm.position,
      "allow-html": _vm.allowHtml,
      "queue-snackbars": _vm.queueSnackbars
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24865266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Layout.vue
// module id = 233
// module chunks = 0